<template>
  <div class="occupancy">
    <div class="occupancyMain">
      <Icon name="adult" v-for="person in parseInt(data.occupancy)" />
    </div>
    <div v-if="numberOfExtraPersons" class="occupancyExtra">
      <Icon name="plus-bold" />
      <Icon name="adult" v-for="person in numberOfExtraPersons" />
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    data: {}
  })

  const numberOfExtraPersons = computed(() => parseInt(props.data.occupancy_max) - parseInt(props.data.occupancy));
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_occupancy.scss');
</style>